import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Input, Label } from "../input/Input";
import { Button } from "../button/Button";


export function ContatoForm({ onSubmit }) {


  const [formData, setFormData] = useState({

    nome: "",
    empresa: "",
    email: "",
    telefone: "",
    origem: "Cadastro Manual",
    status: "NOVO",
    observacao: ""

  });



  function handleChange(event) {

    const { name, value } = event.target;


    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

  }



  function handleSubmit(event) {

    event.preventDefault();


    onSubmit?.(formData);


    setFormData({

      nome: "",
      empresa: "",
      email: "",
      telefone: "",
      origem: "Cadastro Manual",
      status: "NOVO",
      observacao: ""

    });


  }



  return (

    <div
      className="
        w-full
        max-w-[450px]
        bg-white
        border
        border-border
        p-8
        rounded-card
        shadow-md
        font-body
        space-y-6
      "
    >


      <div className="text-center">


        <div
          className="
            w-12
            h-12
            rounded-xl
            bg-primary
            flex
            items-center
            justify-center
            text-white
            font-display
            font-semibold
            text-2xl
            mx-auto
            mb-3
          "
        >
          S
        </div>



        <h2
          className="
            font-display
            text-h3
            font-bold
            text-text-primary
          "
        >
          Novo Contato
        </h2>



        <p className="text-caption text-text-secondary mt-1">
          Cadastre um novo cliente ou oportunidade comercial.
        </p>


      </div>





      <form
        onSubmit={handleSubmit}
        className="space-y-4"
      >



        <div>

          <Label htmlFor="nome" required>
            Nome
          </Label>


          <Input

            id="nome"

            name="nome"

            type="text"

            placeholder="Nome do contato"

            required

            value={formData.nome}

            onChange={handleChange}

          />

        </div>





        <div>

          <Label htmlFor="empresa">
            Empresa
          </Label>


          <Input

            id="empresa"

            name="empresa"

            type="text"

            placeholder="Nome da empresa"

            value={formData.empresa}

            onChange={handleChange}

          />

        </div>





        <div>

          <Label htmlFor="email" required>
            Email
          </Label>


          <Input

            id="email"

            name="email"

            type="email"

            placeholder="email@empresa.com"

            required

            value={formData.email}

            onChange={handleChange}

          />

        </div>





        <div>

          <Label htmlFor="telefone">
            Telefone
          </Label>


          <Input

            id="telefone"

            name="telefone"

            type="tel"

            placeholder="(00) 00000-0000"

            value={formData.telefone}

            onChange={handleChange}

          />

        </div>





        <div>

          <Label htmlFor="origem">
            Origem
          </Label>


          <select

            id="origem"

            name="origem"

            value={formData.origem}

            onChange={handleChange}

            className="
              w-full
              border
              border-border
              rounded-button
              px-3
              py-2
              bg-white
            "

          >

            <option>
              Cadastro Manual
            </option>

            <option>
              Instagram
            </option>

            <option>
              Google
            </option>

            <option>
              Indicação
            </option>

            <option>
              WhatsApp
            </option>


          </select>


        </div>





        <div>

          <Label htmlFor="observacao">
            Observação
          </Label>


          <textarea

            id="observacao"

            name="observacao"

            placeholder="Informações comerciais"

            value={formData.observacao}

            onChange={handleChange}

            className="
              w-full
              border
              border-border
              rounded-button
              px-3
              py-2
              min-h-[90px]
            "

          />


        </div>





        <Button
          type="submit"
          className="w-full"
        >
          Salvar Contato
        </Button>



      </form>





      <p className="text-center text-caption text-text-secondary">

        <Link

          to="/dashboard"

          className="
            text-primary
            font-semibold
            hover:underline
          "

        >
          Voltar para Dashboard

        </Link>


      </p>



    </div>

  );


}